<div class='title main-title'>{{processTitleOperation | translate}}</div>

<div class="left-container">
    <div *ngIf="isInitialLoading" class="login-initialLoading-div">
        <img alt="loading" src="../../assets/images/spinner.gif"/>
    </div>

    <div @showDivTrigger *ngIf="hasError" class="error-feedback-popup"> 
        <div class="error-feedback-div">
            <div class="form-field">
                <div class="error-feedback-icon"></div>
                <div class="error-feedback-text">
                    <div class="error-feedback-title" id="login-error-title">{{messageTitle | translate}}</div>
                    <div class="error-feedback-description">
                        {{messageDescription | translate:sessionData}}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div @showDivTrigger *ngIf="isToShowReember" class="reember-login-popup"> 
        <div class="reember-login-div">
            <div class="form-field">
                <div class="reember-login-text">
                    <div class="reember-login-title">{{'TITLE.RECUPERAR_DADOS' | translate}}</div>
                    <div class="reember-login-description">
                        {{'RECUPERAR_DADOS.DESCRICAO_RECUPERAR_DADOS' | translate}}
                    </div>
                    <div class="reember-find-balcony-div">
                        <div class="reember-find-balcony-icon"></div>
                        <a href="{{branchURL}}" rel=noopener target="_blank" class="reember-find-balcony-text">{{'RECUPERAR_DADOS.BALCOES_PERTO_DE_MIM' | translate}}</a>
                    </div>
                </div>
                <div (click)="hideReember()" class="cancel-reember-login-icon"></div>
            </div>
        </div>
    </div>

    <section *ngIf="!isInitialLoading" class="login-popup">
        <form [formGroup]="loginForm" (ngSubmit)="doLogin()">
            <div class="login-title-message">{{messageOperation | translate:sessionData}}</div>
            <div class="login-data-div">
                <span class="data-access-label">              
                    {{'LOGIN.DADOS_ACESSO' | translate}}
                </span>

                <span class="data-access-description">
                    {{'LOGIN.MESMOS_ACESSOS_NETBANCO' | translate}}
                </span>

                <div class="form-field" style="margin-top:20px;">
                    <div class="radio-buttons horizontal centered">
                        <mat-radio-group class="radio-option" formControlName="selectedChannel" (change)="clearChannelData()" required>
                            <mat-radio-button [disabled]="operationIndicator === 'E'" [checked]="operationIndicator === 'P'" labelPosition="after" class="radio-input" name="selectedChannel" value="P">
                                {{'LOGIN.PARTICULARES' | translate}}
                            </mat-radio-button>
                            <mat-radio-button [disabled]="operationIndicator === 'P'" [checked]="operationIndicator === 'E'" labelPosition="after" class="radio-input" name="selectedChannel" value="E">
                                {{'LOGIN.EMPRESAS' | translate}}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="username-field-form-field">
                    <div class="username-field-container">
                        <em class="username-field"></em>
                        <input *ngIf="selectedChannel === 'P'" [className]="hasError ? 'error': ''" type="text" [(ngModel)]="username" id="username" [maxLength]="64" formControlName="username"  placeholder="{{'LOGIN.USERNAME' | translate}}">
                        <input *ngIf="selectedChannel === 'E'" [className]="hasError ? 'error': ''" type="text" [(ngModel)]="username" id="username" formControlName="username"  placeholder="{{'LOGIN.USERNAME' | translate}}">
                    </div>
                </div>
                
                <div class="password-field-form-field" style="margin-top:0">   
                    <div class="password-field-container">
                        <em class="password-field"></em>
                        <input *ngIf="selectedChannel === 'P'" [className]="hasError ? 'error': ''" [(ngModel)]="password" id="password" type="password" formControlName="password" size="30" [maxLength]="30" placeholder="{{'LOGIN.PASSWORD' | translate}}" style="margin-top:10px;">
                        <input *ngIf="selectedChannel === 'E'" [className]="hasError ? 'error': ''" [(ngModel)]="password" id="password" type="password" formControlName="password" size="16" [maxLength]="16" placeholder="{{'LOGIN.PASSWORD' | translate}}" style="margin-top:10px;">
                    </div>
                </div>

                <div class="form-field" style="margin-top:15px">   
                    <a class="remember-link" (click)="showHelp()">{{'LOGIN.NAO_RECORDO_DADOS_ACESSO' | translate}}</a>
                </div>

                <div *ngIf="sessionData.providerLink" class="form-field" style="margin-top:15px">
                    <a *ngIf="sessionData.agreementType === 'A'" class="remember-link" (click)="goToProvider()" target="_self">{{'LOGIN.NAO_AUTORIZAR_VOLTAR_ENTIDADE' | translate:sessionData}}</a>
                    <a *ngIf="sessionData.agreementType === 'P' && isLoteOperation()" class="remember-link" (click)="goToProvider()" target="_self">{{'LOGIN.NAO_CONCLUIR_VOLTAR_ENTIDADE' | translate:sessionData}}</a>
                    <a *ngIf="sessionData.agreementType === 'P' && isTransfer() && !isChargingOperation()" class="remember-link" (click)="goToProvider()" target="_self">{{'LOGIN.NAO_AGENDAR_VOLTAR_ENTIDADE' | translate:sessionData}}</a>
                    <a *ngIf="sessionData.agreementType === 'P' && !isTransfer() && !isChargingOperation() && !isLoteOperation()" class="remember-link" (click)="goToProvider()" target="_self">{{'LOGIN.NAO_PAGAR_VOLTAR_ENTIDADE' | translate:sessionData}}</a>
                    <a *ngIf="sessionData.agreementType === 'P' && isChargingOperation()" class="remember-link" (click)="goToProvider()" target="_self">{{'LOGIN.NAO_CARREGAR_VOLTAR_ENTIDADE' | translate:sessionData}}</a>
                </div>

                <div id="captcha-div" *ngIf="captchaSiteKey" class="captcha-div">
                    <re-captcha class="g-recaptcha" (resolved)="resolved($event)" *ngIf="showCaptcha" siteKey="{{captchaSiteKey}}"></re-captcha>
                </div>

                <div class="form-buttons" style="margin-top:30px;">
                    <button type="button" *ngIf="(!loginForm.valid && !isLoading) || (showCaptcha && !answeredCaptcha) else BtnConfirmEnable;" class="submit-btn fixed-width-btn disabled" id="btn-submit">{{'LOGIN.AUTENTICAR' | translate}}</button>
                    <ng-template #BtnConfirmEnable>
                        <button type="submit" *ngIf="!isLoading" class="submit-btn fixed-width-btn" id="btn-submit">{{'LOGIN.AUTENTICAR' | translate}}</button>
                    </ng-template>
                    <div *ngIf="isLoading" id="loading-div" class="loading-div">
                        <img alt="loading" src="../../assets/images/spinner.gif" />
                    </div>
                </div>
            </div>
        </form>
    </section>
</div>
